import * as React from "react";
import { cn } from "@/lib/utils";

type El = React.HTMLAttributes<HTMLElement> & { as?: keyof JSX.IntrinsicElements };

const make = (base: string, defaultTag: keyof JSX.IntrinsicElements) => {
  const Comp = ({ as, className, ...props }: El) => {
    const Tag = (as ?? defaultTag) as any;
    return <Tag className={cn(base, className)} {...props} />;
  };
  Comp.displayName = `DS(${defaultTag})`;
  return Comp;
};

export const Display = make("ds-display", "h1");
export const H1 = make("ds-h1", "h1");
export const H2 = make("ds-h2", "h2");
export const H3 = make("ds-h3", "h3");
export const H4 = make("ds-h4", "h4");
export const H5 = make("ds-h5", "h5");
export const H6 = make("ds-h6", "h6");
export const Lead = make("ds-lead", "p");
export const Body = make("ds-body", "p");
export const Caption = make("ds-caption", "p");
export const Label = make("ds-label", "span");
export const Stat = make("ds-stat", "span");
export const Legal = make("ds-legal", "p");
export const Eyebrow = ({ className, dot = true, ...props }: El & { dot?: boolean }) => (
  <p className={cn("eyebrow", dot && "eyebrow-dot", className)} {...props} />
);

export const TextLink = ({
  className,
  external,
  children,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & { external?: boolean }) => (
  <a
    className={cn("ds-link", className)}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    {...props}
  >
    {children}
  </a>
);
